import * as client from '../../services/client';
import { TYPES, PATHS } from '../../common/constants';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { stopPRLoading, startPRLoading, startFormLoading, stopFormLoading } from './loader';
import { setValidation } from './validation';
import { fetchfilteredServiceRequestByStatusAndDays } from '../actions/serviceRequests'

export const fetchServiceRequestsByGroupDone = (payload) => ({
    type: TYPES.SAVE_SERVICE_REQUEST_BY_GROUP,
    payload,
  });

  export const setCurrentGroupServiceRequestIndex = (payload) => ({
    type: TYPES.SET_CURRENT_GROUP_SERVICE_REQUEST_INDEX,
    payload,
  });
   // Modified by: Tarkeshwar Prasad Yadav
      // Modified on: 30/08/2022
      // Jira ticket: JUN-3111
      // Comment: All Tenants: added checkbox to show only active or closed service requests.
  export const setDisplayClosedAndResolvedTickets = (payload) => ({
    type: TYPES.SET_DISPLAY_CLOSE_AND_RESOLVED_TICKETS,
    payload,
  });
export const clearServiceRequestByGroup = (payload) => ({
    type: TYPES.CLEAR_SAVE_SERVICE_REQUEST_BY_GROUP,
    payload
});

export const deleteServiceRequestGroup = (groupingServiceRequestId,userId,params1) => dispatch => {
  dispatch(startFormLoading())
  return client.deleteServiceRequestGroup(groupingServiceRequestId,userId)
    .then(
      response => {
        if (response.ok || response.status === 200) {
          response.json().then(
            (responsejson) => {
              if(responsejson.statusCode === 200) {
               toast.success('ⓘ Service Request group has been deleted.',{autoClose:10000,position:'top-center'})
                dispatch( fetchfilteredServiceRequestByStatusAndDays(
                  params1.userID,
                  params1.role,
                  params1.status,
                  params1.cdays,
                  params1.count,
                  params1.text,
                  params1.search,
                  params1.filterValues
                ))
                dispatch(clearServiceRequestByGroup());
                dispatch(stopFormLoading())

              } else {
                dispatch(clearServiceRequestByGroup());
                dispatch(stopFormLoading())
                toast.error(' 🚫 Something went wrong with deleting a Service Request group, please try again.',{autoClose:12000,position:'top-center'})
              }
            }
          )
        } else {
          toast.error(' 🚫 Something went wrong with deleting a Service Request group, please try again.',{autoClose:12000,position:'top-center'})
          dispatch(clearServiceRequestByGroup());
          dispatch(stopFormLoading())
        }
      }
   );
};


export const deleteServiceRequestFromGroup = (serviceRequestId,usersId,params1) => dispatch => {
  dispatch(startFormLoading())
  return client.deleteServiceRequestFromGroup(serviceRequestId,usersId)
    .then(
      response => {
        if (response.ok || response.status === 200) {
          response.json().then(
            (responsejson) => {
              if(responsejson.statusCode === 200) {
               toast.success('ⓘ Service Request has been removed from the group.',{autoClose:10000,position:'top-center'})
               dispatch( fetchfilteredServiceRequestByStatusAndDays(
                params1.userID,
                params1.role,
                params1.status,
                params1.cdays,
                params1.count,
                params1.text,
                params1.search,
                params1.filterValues
              ))
              dispatch(clearServiceRequestByGroup());
              dispatch(stopFormLoading())                
              } else {
                dispatch(stopFormLoading())
                toast.error(' 🚫 Something went wrong with deleting a Service Request from group, please try again.',{autoClose:12000,position:'top-center'})
              }
            }
          )
        } else {
          toast.error(' 🚫 Something went wrong with deleting a Service Request from group, please try again.',{autoClose:12000,position:'top-center'})
          dispatch(stopFormLoading())
        }
      }
   );
};